import Api from "../apiService";

class referenceItemsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/reference_items`,
      params,
      Api.authHeaders()
    );
  }

  targets(companyId) {
    return Api.getRequest(
      `companies/${companyId}/reference_items/targets`,
      {},
      Api.authHeaders()
    );
  }

  show(companyId, id, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/reference_items/${id}`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/reference_items`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/reference_items/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/reference_items/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/reference_items/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }
}

export default new referenceItemsApi();
